import { RetryPlugin } from '@vk-tech-solar/module-federation-retry-plugin';
import { HostEnvironment } from '../../src/HostEnvironment.js';
const runtimePlugin = () => {
    const STORAGE_KEY = 'last_static_fallback_success';
    return RetryPlugin({
        getLastSuccessHost: () => sessionStorage.getItem(STORAGE_KEY) || '',
        hosts: HostEnvironment.staticHosts,
        onSuccess: (url) => {
            if (url) {
                const { protocol, hostname } = new URL(url);
                sessionStorage.setItem(STORAGE_KEY, `${protocol}//${hostname}`);
            }
        },
    });
};
export default runtimePlugin;
